/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {IConfig as ɵb} from './lib/interfaces/config.interface';
export {ConfigService as ɵa} from './lib/services/config.service';